// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"d33cddd6","668":"f3176f66"}[chunkId] + ".chunk.css";
};